import React, { useState, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import { apiUrl } from '../services/http/http';
import ProfileService from '../services/profile/profile';
//import ActiveRequestsService from '../services/active-requests/active-requests';
import { Link } from 'react-router-dom';
import {
  Editor,
  EditorProvider,
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnUnderline,
  BtnBulletList,
  BtnNumberedList,
  BtnLink,
  BtnUndo,
  BtnRedo,
  Separator,
  createDropdown
} from 'react-simple-wysiwyg';
import Collapsible from 'react-collapsible';
import user_icon from './user_icon.png';

import ReactTooltip from 'react-tooltip';
import masterListSource from './MasterList';

// const $ = window.$;

const BtnCustomStyles = createDropdown('Styles', [
  ['Normal', 'formatBlock', 'DIV'],
  ['Header 4', 'formatBlock', 'H4']
]);

export const ProfileMap = props => {
  //const activeRequests = new ActiveRequestsService();
  const profileService = new ProfileService();

  const [profile, setProfile] = useState();
  const [framework, setFramework] = useState();
  const [frameworkInfo, setFrameworkInfo] = useState();

  //const [ksa, setKsa] = useState();
  const [mapping, setMapping] = useState();

  const frameworkName = props.location.pathname.split('/')[2];
  const frameworkVersion = props.location.pathname.split('/')[3];
  const profileId = props.location.pathname.split('/')[6];
  const [mappingFreeText, setMappingFreeText] = useState('');

  var competencyForm = '';
  var expertise_levels = [];
  var expertise_levels_legend = [];
  var expertise_not_applicable = '';
  var attribute_types = [];
  var frameworkFullName = '';

  useEffect(() => {
    const fetchData = async () => {
      await fetch(
        `${apiUrl}/api/${frameworkName}/${frameworkVersion}/profiles?_format=json&id=${profileId}&source=competencyhub&timestamp=${Date.now()}`
      )
        .then(Response => Response.json())
        .then(findresponse => {
          setProfile(findresponse);
          setMappingFreeText(findresponse.profile_mapping_freetext);
        });

      await fetch(
        `${apiUrl}/api/version_manager?_format=json&source=competencyhub`
      )
        .then(Response => Response.json())
        .then(findresponse => {
          setFrameworkInfo(findresponse);
        });

      await fetch(
        `${apiUrl}/api/${frameworkName}/${frameworkVersion}?_format=json&source=competencyhub&timestamp=${Date.now()}`
      )
        .then(Response => Response.json())
        .then(findresponse => {
          setFramework(findresponse);
        });
    };
    fetchData();
  }, [profileId, frameworkName, frameworkVersion, mapping]);

  const handleSubmit = async e => {
    e.preventDefault();
    profileService.mapProfile(profileId, mapping);
    props.history.push(
      `/framework/${frameworkName}/${frameworkVersion}/profile/view/${profileId}/alias`
    );
  };

  const handleSelect = event => {
    let competency_id = event.target[event.target.selectedIndex].getAttribute(
      'data-competency'
    );
    let expertise_id = event.target[event.target.selectedIndex].getAttribute(
      'data-expertise'
    );
    let tempMapping = mapping;

    let attributesList = [];
    // let checkBoxes = $('input:checkbox[data-competency="' + competency_id + '"]');
    let checkBoxes = document.querySelectorAll(
      'input[type="checkbox"][data-competency="' + competency_id + '"]'
    );

    if (expertise_id === expertise_not_applicable) {
      checkBoxes.forEach(function(item, index, arr) {
        item.checked = false;
        item.disabled = true;
      });

      // Remove the NA competency from the temp array
      tempMapping = tempMapping.filter(o => o.competency !== competency_id);
    } else if (tempMapping) {
      if (tempMapping.find(o => o.competency === competency_id)) {
        let o = tempMapping.find(o => o.competency === competency_id);
        o.expertise = expertise_id;

        checkBoxes.forEach(function(item, index, arr) {
          attributesList.push(item.id);
          item.checked = true;
          item.disabled = false;
        });
        o.attributes = attributesList;
      } else {
        checkBoxes.forEach(function(item, index, arr) {
          attributesList.push(item.id);
          item.checked = true;
          item.disabled = false;
        });
        tempMapping.push({
          competency: competency_id,
          expertise: expertise_id,
          attributes: attributesList
        });
      }
    }
    setMapping(tempMapping);
  };

  const handleCheckBox = e => {
    let checkboxStatus = e.target.checked;
    let competency_id = e.target.dataset.competency;
    let tempMapping = mapping;
    if (tempMapping) {
      if (checkboxStatus === true) {
        e.target.checked = true;
        let o = tempMapping.find(o => o.competency === competency_id);
        o.attributes.push(e.target.id);
      } else {
        let o = tempMapping.find(o => o.competency === competency_id);
        o.attributes.splice(o.attributes.indexOf(e.target.id), 1);
      }
      setMapping(tempMapping);
    }
  };

  const changeMappingFreeText = event => {
    setMappingFreeText(event.target.value);
  };

  const handleFreeTextSubmit = async e => {
    e.preventDefault();
    await profileService.mapProfileFreeText(profileId, mappingFreeText);
    props.history.push(
      `/framework/${frameworkName}/${frameworkVersion}/profile/view/${profileId}/alias`
    );
  };

  const setExpertiseLevels = levels => {
    levels.map((level, index) => {
      expertise_levels[level.id] = level.title;
      expertise_not_applicable =
        level.title === 'Not applicable' ? level.id : '';
      expertise_levels_legend.push(
        <li
          key={index}
          className="vf-list__item"
          style={{ textAlign: 'center' }}
        >
          <div
            data-tip={level.description ? level.description : 'NA'}
            data-html={true}
            data-type="info"
            data-multiline={true}
          >
            <span className="vf-badge vf-badge--tertiary">
              {' '}
              {level.rating_level}{' '}
            </span>{' '}
            <span> {level.title}</span>
          </div>
          <ReactTooltip className="tooltip-custom" />
        </li>
      );
      return null;
    });
  };

  const generateForm = () => {
    if (frameworkInfo) {
      frameworkInfo.map(info => {
        if (info.machine_name === frameworkName) {
          frameworkFullName = info.title;
          setExpertiseLevels(info.expertise_levels);
        }
        return null;
      });
      frameworkInfo.map(info => {
        if (info.title.toLowerCase() === frameworkName) {
          info.attribute_types.map(
            attribute => (attribute_types[attribute.id] = attribute.title)
          );
        }
        return null;
      });
    }

    if (profile) {
      if (!mapping) {
        setMapping(profile.profile_mapping);
      }
    }

    if (framework) {
      let domains = [];
      if (framework[0].core_domains && framework[0].core_domains.length > 0) {
        domains = framework[0].core_domains;
        domains = domains.concat(framework[0].domains);
      } else {
        domains = framework[0].domains;
      }
      competencyForm = domains.map((domain, did) => (
        <ul key={did}>
          <li className="domain_list">
            <div className="row callout">
              <div className="column medium-9">
                <h5 className="domain_title"> {domain.title}</h5>
              </div>
            </div>
            <ul>
              {domain.competencies.map((competency, cid) => (
                <li key={cid} className="competency_list">
                  <div className="vf-grid vf-grid__col-4">
                    <div className="vf-grid__col--span-3">
                      <Collapsible
                        trigger={
                          <div className="open-close-title">
                            <span className="icon icon-common icon-angle-right icon-custom">
                              {' '}
                            </span>
                            <span>{competency.title}</span>
                          </div>
                        }
                        triggerWhenOpen={
                          <div className="open-close-title">
                            <span className="icon icon-common icon-angle-down icon-custom">
                              {' '}
                            </span>
                            <span>{competency.title}</span>
                          </div>
                        }
                      >
                        <ul>
                          {attribute_types.map((attribute_type, key) => {
                            return (
                              <li key={key} className="attribute_type">
                                {attribute_type}
                                <ul>
                                  {competency.attributes
                                    .filter(
                                      attribute =>
                                        attribute.type === attribute_type
                                    )
                                    .map((attribute, key) => (
                                      <li key={key} className="attribute_title">
                                        <div className="vf-grid vf-grid__col-4">
                                          <div className="vf-grid__col--span-1">
                                            <input
                                              type="checkbox"
                                              id={attribute.id}
                                              onChange={e => handleCheckBox(e)}
                                              defaultChecked={
                                                mapping.find(o =>
                                                  o.attributes.find(
                                                    a => a === attribute.id
                                                  )
                                                )
                                                  ? true
                                                  : false
                                              }
                                              disabled={
                                                mapping.find(
                                                  o =>
                                                    o.competency ===
                                                    competency.id
                                                )
                                                  ? false
                                                  : true
                                              }
                                              data-competency={competency.id}
                                            />
                                          </div>
                                          <div className="vf-grid__col--span-3">
                                            <label
                                              className="attribute_label"
                                              htmlFor={attribute.id}
                                            >
                                              {' '}
                                              {attribute.title}
                                            </label>
                                          </div>
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                              </li>
                            );
                          })}
                        </ul>
                      </Collapsible>
                    </div>
                    <div className="vf-grid__col--span-1">
                      <select
                        className="vf-form__select"
                        onChange={e => handleSelect(e)}
                        defaultValue={
                          mapping.find(o => o.competency === competency.id)
                            ? mapping.find(o => o.competency === competency.id)
                                .expertise
                            : expertise_not_applicable
                        }
                      >
                        {expertise_levels.map((key, value) => (
                          <option
                            value={value}
                            data-expertise={value}
                            data-competency={competency.id}
                            key={key}
                          >
                            {key}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      ));
    }
  };

  return (
    <div>
      {generateForm()}
      {profile ? (
        <div>
          <div className="row">
            <div className="vf-u-margin__top--400" />
            <h2> Competency mapping</h2>
            <h3>
              {
                masterListSource.filter(item => item.title === frameworkName)[0]
                  .new_desc
              }{' '}
              ({frameworkFullName} {frameworkVersion}) - {profile.job_title}{' '}
            </h3>

            <div className="column medium-12">
              <div className="row">
                <div className="column medium-10" />
                <div className="column medium-2">
                  <Link
                    to={`/framework/${frameworkName}/${frameworkVersion}/profile/view/${profileId}/alias`}
                  >
                    <i className="icon icon-common icon-angle-left" /> Profile
                    overview
                  </Link>
                  <p />
                </div>
              </div>

              <div className="row">
                <div className="column medium-3">
                  <img
                    alt=""
                    src={profile.image[0] ? profile.image[0].url : user_icon}
                    width="150px"
                  />
                </div>
                <div className="column medium-9 form_intro">
                  <p>
                    Select the level of expertise in each competency from the
                    dropdown menu. Choose the knowledge, skills and attitudes
                    that are applicable to you by clicking on each competency to
                    view them
                  </p>
                </div>
              </div>
              <div className="vf-grid vf-grid__col-4">
                <div className="vf-grid__col--span-1">
                  {' '}
                  <h5 style={{ marginTop: '25px' }}>
                    {frameworkFullName} {frameworkVersion} / Competencies
                  </h5>
                </div>
                <div className="vf-grid__col--span-3">
                  <ul
                    className="vf-list legend-inline"
                    style={{ float: 'right' }}
                  >
                    {expertise_levels_legend}
                  </ul>
                </div>
              </div>
              <hr />

              <div className="competency_section">
                {frameworkName === 'abdc' ? (
                  <form onSubmit={e => handleFreeTextSubmit(e)}>
                    <EditorProvider>
                      <Editor
                        containerProps={{
                          style: { resize: 'vertical', height: '150px' }
                        }}
                        value={mappingFreeText}
                        onChange={changeMappingFreeText}
                        required
                      >
                        <Toolbar>
                          <BtnUndo />
                          <BtnRedo />
                          <Separator />
                          <BtnBold />
                          <BtnItalic />
                          <BtnUnderline />
                          <Separator />
                          <BtnCustomStyles />
                          <Separator />
                          <BtnBulletList />
                          <BtnNumberedList />
                          <Separator />
                          <BtnLink />
                        </Toolbar>
                      </Editor>
                    </EditorProvider>
                    <div className="submit_fixed">
                      <button
                        className="vf-button vf-button--primary vf-button--sm"
                        type="submit"
                      >
                        Save <i className="icon icon-common icon-save" />
                      </button>
                    </div>
                  </form>
                ) : (
                  <form onSubmit={e => handleSubmit(e)}>
                    {competencyForm}
                    <div className="submit_fixed">
                      <button
                        className="vf-button vf-button--primary vf-button--sm"
                        type="submit"
                      >
                        Save <i className="icon icon-common icon-save" />
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        'Loading'
      )}
    </div>
  );
};

export const MapProfile = () => (
  <Switch>
    <Route
      exact
      path="/framework/:framework/:version/profile/map/:id"
      component={ProfileMap}
    />
  </Switch>
);

export default MapProfile;
